import { useEffect } from 'react'
import { Stack, useNavigation, useRouter } from 'expo-router'
import { StackActions } from '@react-navigation/native'

/**
 * Fixtures tab is a stack: index = scoreboard; league-detail pushed on top so Back
 * pops without remounting or refetching the Fixtures screen.
 */
export default function GameResultsStackLayout() {
  const navigation = useNavigation()
  const router = useRouter()

  useEffect(() => {
    const parent = navigation.getParent()
    if (!parent) return
    const unsubscribe = parent.addListener(
      'tabPress' as Parameters<typeof parent.addListener>[0],
      () => {
        navigation.dispatch(StackActions.popToTop())
        router.replace('/app/gameResults' as never)
      }
    )
    return unsubscribe
  }, [navigation, router])

  return (
    <Stack screenOptions={{ headerShown: false, animation: 'slide_from_right' }}>
      <Stack.Screen name="index" />
      <Stack.Screen name="league-detail" />
    </Stack>
  )
}
